import React, { FC } from 'react';
import { IconProps } from '.';

export const PencilIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg fill="none" {...sizing} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="m18.26 4.97.76.77c.64.63.64 1.66 0 2.3L7.56 19.5H4.5v-3.06L15.97 4.97a1.62 1.62 0 0 1 2.29 0Z"
                clipRule="evenodd"
            />
            <path stroke="url(#d7290702)" strokeLinecap="round" strokeLinejoin="round" d="m6 16 2.5 2.5" />
            <defs>
                <linearGradient id="d7290702" x1="6" x2="6" y1="16.61" y2="18.5" gradientUnits="userSpaceOnUse">
                    <stop stopColor="currentColor" stopOpacity=".5" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
